import { render, staticRenderFns } from "./CreateBlog.vue?vue&type=template&id=412f11c7"
import script from "./CreateBlog.vue?vue&type=script&lang=js"
export * from "./CreateBlog.vue?vue&type=script&lang=js"
import style0 from "./CreateBlog.vue?vue&type=style&index=0&id=412f11c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports